import { Component, h, Prop, Host } from '@stencil/core';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-proxio-productcard-pricelink',
  styleUrl: 'pn-proxio-productcard-pricelink.scss',
})
export class PnProxioProductcardPricelink {
  @Prop() price: string;
  @Prop() vatText: string = '';
  @Prop() link: string;
  @Prop() linktext: string;

  render() {
    return this.link && this.linktext ? (
      <Host>
        {this.price ? (
          <h3>
            {this.price} <span class="pn-pricelink-vat">{this.vatText}</span>
          </h3>
        ) : null}
        <pn-button small="true" icon={arrow_right} appearance="light" href={this.link} target="_blank" rel="noopener nofollower noreferrer">
          {this.linktext}
        </pn-button>
      </Host>
    ) : null;
  }
}
